import { render, staticRenderFns } from "./BContainerWrapper.vue?vue&type=template&id=d49d36f8"
import script from "./BContainerWrapper.vue?vue&type=script&lang=js"
export * from "./BContainerWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports